const CATEGORIAS_CON_TIPO_TINTA = [7, 8];

const estaVacio = (valor) => valor === null || valor === undefined || valor === '';

const codigoCategoria = (categoria) =>
  Number(
    categoria?.Codigo ?? categoria?.CodigoCategoria ?? categoria?.CodigoCategoriaMaterial ?? 0,
  );

export function reasignarTipoTintaPorCambioDeProceso(categorias, defectoAnterior, defectoNuevo) {
  if (!Array.isArray(categorias)) return categorias;
  const nuevo = defectoNuevo ?? null;
  const anterior = defectoAnterior ?? null;

  let huboCambios = false;
  const resultado = categorias.map((categoria) => {
    if (!CATEGORIAS_CON_TIPO_TINTA.includes(codigoCategoria(categoria))) return categoria;
    const filas = Array.isArray(categoria.ElementoMateriales) ? categoria.ElementoMateriales : [];

    let categoriaCambio = false;
    const filasNuevas = filas.map((fila) => {
      if (Number(fila?.Codigo) > 0) return fila;
      const actual = fila?.CodigoTintaTipo;
      const esDefaultAnterior = anterior !== null && Number(actual) === anterior;
      if (!estaVacio(actual) && !esDefaultAnterior) return fila;
      if ((actual ?? null) === nuevo) return fila;
      categoriaCambio = true;
      return { ...fila, CodigoTintaTipo: nuevo };
    });

    if (!categoriaCambio) return categoria;
    huboCambios = true;
    return { ...categoria, ElementoMateriales: filasNuevas };
  });

  return huboCambios ? resultado : categorias;
}

const CODIGO_TINTA_GENERICA = 2;
const TINTA_GENERICA = Object.freeze({
  Codigo: CODIGO_TINTA_GENERICA,
  DescripcionInterna: 'Tinta Generica',
  Activo: true,
});

export function camposTintaPorDefecto(material) {
  const tinta = material?.Codigo ? { ...material } : { ...TINTA_GENERICA };
  return { Material: tinta, MaterialDesc: tinta.DescripcionInterna };
}

export function reasignarTintaPorCambioDeProceso(categorias, defectoAnterior, defectoNuevo) {
  if (!Array.isArray(categorias)) return categorias;
  const codigoAnterior = defectoAnterior?.Codigo ?? null;
  const codigoNuevo = defectoNuevo?.Codigo ?? CODIGO_TINTA_GENERICA;

  let huboCambios = false;
  const resultado = categorias.map((categoria) => {
    if (!CATEGORIAS_CON_TIPO_TINTA.includes(codigoCategoria(categoria))) return categoria;
    const filas = Array.isArray(categoria.ElementoMateriales) ? categoria.ElementoMateriales : [];

    let categoriaCambio = false;
    const filasNuevas = filas.map((fila) => {
      if (Number(fila?.Codigo) > 0) return fila;
      const actual = fila?.Material?.Codigo;
      const esReemplazable =
        estaVacio(actual) ||
        Number(actual) === CODIGO_TINTA_GENERICA ||
        (codigoAnterior !== null && Number(actual) === codigoAnterior);
      if (!esReemplazable || Number(actual) === codigoNuevo) return fila;
      categoriaCambio = true;
      const campos = camposTintaPorDefecto(defectoNuevo);
      const nueva = { ...fila, ...campos };
      if ('CodigoTinta' in fila) nueva.CodigoTinta = campos.Material.Codigo;
      return nueva;
    });

    if (!categoriaCambio) return categoria;
    huboCambios = true;
    return { ...categoria, ElementoMateriales: filasNuevas };
  });

  return huboCambios ? resultado : categorias;
}

const esCategoriaBarniz = (categoria) => {
  const descripcion = String(categoria?.Descripcion || '')
    .trimStart()
    .toLowerCase();
  return descripcion === 'barniz' || descripcion.startsWith('barniz ');
};

export function reasignarBarnizPorCambioDeProceso(categorias, defectoAnterior, defectoNuevo) {
  if (!Array.isArray(categorias)) return categorias;
  const codigoAnterior = defectoAnterior?.Codigo ?? null;
  const codigoNuevo = defectoNuevo?.Codigo ?? null;

  let huboCambios = false;
  const resultado = categorias.map((categoria) => {
    if (!esCategoriaBarniz(categoria)) return categoria;
    const filas = Array.isArray(categoria.ElementoMateriales) ? categoria.ElementoMateriales : [];

    let categoriaCambio = false;
    const filasNuevas = filas.map((fila) => {
      if (Number(fila?.Codigo) > 0) return fila;
      const actual = fila?.Material?.Codigo;
      const esReemplazable =
        estaVacio(actual) || (codigoAnterior !== null && Number(actual) === codigoAnterior);
      if (!esReemplazable || (actual ?? null) === codigoNuevo) return fila;
      categoriaCambio = true;
      const nueva = defectoNuevo?.Codigo
        ? { ...fila, Material: { ...defectoNuevo }, MaterialDesc: defectoNuevo.DescripcionInterna }
        : { ...fila, Material: {}, MaterialDesc: '' };
      if ('CodigoTinta' in fila) nueva.CodigoTinta = codigoNuevo;
      return nueva;
    });

    if (!categoriaCambio) return categoria;
    huboCambios = true;
    return { ...categoria, ElementoMateriales: filasNuevas };
  });

  return huboCambios ? resultado : categorias;
}

export function reasignarCoberturaPorCambioDeProceso(categorias, defectos) {
  if (!Array.isArray(categorias)) return categorias;

  let huboCambios = false;
  const resultado = categorias.map((categoria) => {
    const defecto = CATEGORIAS_CON_TIPO_TINTA.includes(codigoCategoria(categoria))
      ? defectos?.tinta
      : esCategoriaBarniz(categoria)
        ? defectos?.barniz
        : null;
    if (!defecto || defecto.anterior === defecto.nuevo) return categoria;
    const filas = Array.isArray(categoria.ElementoMateriales) ? categoria.ElementoMateriales : [];

    let categoriaCambio = false;
    const filasNuevas = filas.map((fila) => {
      if (Number(fila?.Codigo) > 0) return fila;
      if (estaVacio(fila?.Cobertura) || Number(fila.Cobertura) !== defecto.anterior) return fila;
      categoriaCambio = true;
      return { ...fila, Cobertura: defecto.nuevo };
    });

    if (!categoriaCambio) return categoria;
    huboCambios = true;
    return { ...categoria, ElementoMateriales: filasNuevas };
  });

  return huboCambios ? resultado : categorias;
}
